var _circle, _circle2, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#359943",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 58.752,
    fill: "#359943",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.222,
    height: 87.224,
    x: 31.496,
    y: 30.285,
    fill: "#359943",
    rx: 43.611
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.405,
    d: "M91.004 72.313v-6.736c0-5.612-2.245-7.858-7.858-7.858h-6.735c-5.613 0-7.858 2.246-7.858 7.858v1.764h4.971c5.613 0 7.858 2.246 7.858 7.858v4.972h1.764c5.613 0 7.858-2.245 7.858-7.858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.405,
    d: "M81.382 81.935v-6.736c0-5.612-2.245-7.858-7.858-7.858H66.79c-5.613 0-7.858 2.246-7.858 7.858v6.736c0 5.612 2.245 7.858 7.858 7.858h6.735c5.613 0 7.858-2.246 7.858-7.858z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.405,
    d: "m65.474 78.567 3.127 3.127 6.239-6.254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.e622ace33029252b79b1775c25772ff5.svg";
export { ForwardRef as ReactComponent };